"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var Query_1 = require("./Query");
var BaseQuery_1 = require("./BaseQuery");
var DocumentEntityQuery = /** @class */ (function (_super) {
    __extends(DocumentEntityQuery, _super);
    function DocumentEntityQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentEntityQuery.prototype.getOptions = function () {
        var _a = this.queryOptions.options, options = _a === void 0 ? {} : _a;
        return options.documentEntity;
    };
    DocumentEntityQuery.prototype.getRawValue = function (executionOptions) {
        var _a;
        var _b;
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            var contextConfiguration = Query_1.Query.getContextConfiguration(executionOptions, this.queryOptions);
            var documentEntityKeysConfig = contextConfiguration.documentEntityKeys;
            var documentEntities = context.documentEntities, documentJoinMap = context.documentJoinMap, document_1 = context.document;
            var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
            if (((_b = Object.keys(documentEntities)) === null || _b === void 0 ? void 0 : _b.length) === 0) {
                return;
            }
            // document context programmatically loaded by the app
            var documentClientCode = document_1.clientCode;
            // join map loaded into context by the API
            var entityClientCodes = documentJoinMap[documentClientCode];
            if (documentEntityKeysConfig) {
                // Config keys that would contain the conditions to filter the entities (user defined category)
                var configEntityKeys = Object.keys(documentEntityKeysConfig);
                // Building up IQueryOptions due to options nesting for different queryOptionTypes that can be use to Query
                var queryOptionsProperty = {
                    queryOptionsType: 'property',
                    options: {
                        property: this.getOptions().property
                    }
                };
                // Load the entity query to fetch the property data (properties_pub only supported by the API at time of writing)
                var query = new Query_1.Query(queryOptionsProperty, this.translationHelper);
                var overrideExecutionOptions = {
                    context: {
                        documentEntityByKeys: {},
                    },
                };
                for (var _i = 0, entityClientCodes_1 = entityClientCodes; _i < entityClientCodes_1.length; _i++) {
                    var clientCode = entityClientCodes_1[_i];
                    var entity = documentEntities[clientCode];
                    if (entity) {
                        for (var _c = 0, configEntityKeys_1 = configEntityKeys; _c < configEntityKeys_1.length; _c++) {
                            var key = configEntityKeys_1[_c];
                            var documentEntityByKeys = overrideExecutionOptions.context.documentEntityByKeys;
                            if (!documentEntityByKeys[key]) {
                                // Build up conditional execution options to allow the query options instead of the dot notation when configuring
                                var conditionalExecutionOptions = query.mergeExecutionOptions(executionOptions, {
                                    context: {
                                        entityByType: (_a = {},
                                            _a[entity.type] = entity,
                                            _a)
                                    }
                                });
                                var valid = conditionalHelper.matches(entity, documentEntityKeysConfig[key].conditional, conditionalExecutionOptions);
                                if (valid) {
                                    documentEntityByKeys[key] = entity;
                                }
                            }
                        }
                    }
                }
                var workingExecutionOptions = query.mergeExecutionOptions(executionOptions, overrideExecutionOptions || {});
                // Fire off the option query using new context
                return query.execute(workingExecutionOptions);
            }
            else {
                console.error('The documentEntity query requires context.data.documentEntityKeys to be configured');
            }
        }
    };
    return DocumentEntityQuery;
}(BaseQuery_1.BaseQuery));
exports.DocumentEntityQuery = DocumentEntityQuery;
//# sourceMappingURL=DocumentEntityQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/DocumentEntityQuery.js
// module id = 945
// module chunks = 1